var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ex_live_pro",class:{is_show:_vm.isShow&&_vm.dataVal},on:{"click":function($event){return _vm.LinkProduct(_vm.dataVal.ProductId)}}},[(_vm.dataVal.Banner)?_c('img',{attrs:{"src":_vm.dataVal.Banner}}):_c('img',{attrs:{"src":require("@/assets/img/empty.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }